import { Component, OnInit, ViewChild, HostListener, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { trigger, style, query, transition, stagger, animate } from '@angular/animations';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger("animateMenu", [
      transition(":enter", [
        query("*", [
          style({ opacity: 0, transform: "translateY(-50%)" }),
          stagger(50, [
            animate(
              "250ms cubic-bezier(0.35, 0, 0.25, 1)",
              style({ opacity: 1, transform: "none" })
            )
          ])
        ])
      ])
    ])
  ]
})
export class HeaderComponent implements OnInit {

  responsiveMenuVisible: Boolean = false;
  pageYPosition: number;
  languageFormControl: FormControl = new FormControl();
  cvName: string = "";

  // Add the header text as properties
  headerText = {
    Item1: 'About me',
    Item2: 'Experience',
    Item3: 'Projects',
    Item4: 'Contact',
    cvBtn: 'Resume',
    cvName: 'PAVAN_MEKALA_RESUME.pdf',
    Pretitle: "Hello!  I am"
  };

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {

  }

  scroll(el) {
    if (document.getElementById(el)) {
      document.getElementById(el).scrollIntoView({ behavior: 'smooth' });
    } else {
      this.router.navigate(['/home']).then(() => document.getElementById(el).scrollIntoView({ behavior: 'smooth' }));
    }
    this.responsiveMenuVisible = false;
  }

  downloadCV() {
    this.cvName = this.headerText.cvName;
    console.log(this.cvName);
    // app url
    let url = window.location.href;

    // Open the file in a new tab
    window.open(url + "/../assets/cv/" + this.cvName, "_blank");

    // Set a timeout for the download
    setTimeout(() => {
      // Create a temporary anchor element for download
      const link = document.createElement('a');
      link.href = url + "/../assets/cv/" + this.cvName;
      link.download = this.cvName; // Set the file name for download

      // Append to the body
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      // Clean up
      document.body.removeChild(link);
    }, 5000); // 5000 milliseconds = 5 seconds
  }

  @HostListener('window:scroll', ['getScrollPosition($event)'])
  getScrollPosition(event) {
    this.pageYPosition = window.pageYOffset;
  }
}
